import * as React from "react";
const TechDrivenSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={57}
    height={56}
    fill="none"
    {...props}
  >
    <rect
      width={48}
      height={48}
      x={4.332}
      y={4}
      fill="#fff"
      fillOpacity={0.03}
      rx={24}
    />
    <rect
      width={48}
      height={48}
      x={4.332}
      y={4}
      stroke="#fff"
      strokeOpacity={0.06}
      strokeWidth={8}
      rx={24}
    />
    <path
      fill="#fff"
      d="M30.25 37a.75.75 0 0 1-.75.75h-3a.75.75 0 1 1 0-1.5h3a.75.75 0 0 1 .75.75ZM28 26.5a1.125 1.125 0 1 0 0-2.251 1.125 1.125 0 0 0 0 2.25Zm8.964 4.108-1.159 5.216a1.5 1.5 0 0 1-2.391.854l-2.554-1.929H25.14l-2.556 1.929a1.5 1.5 0 0 1-2.391-.854l-1.159-5.216a1.508 1.508 0 0 1 .311-1.285l2.678-3.212c.09-1.18.36-2.34.803-3.438 1.21-3.032 3.375-4.934 4.254-5.61a1.5 1.5 0 0 1 1.837 0c.876.676 3.044 2.578 4.254 5.61.442 1.098.713 2.258.803 3.438l2.678 3.212a1.508 1.508 0 0 1 .31 1.285ZM25.32 33.25h5.357c1.98-3.52 2.35-6.889 1.1-10.02-1.102-2.764-3.17-4.511-3.778-4.98-.61.469-2.679 2.216-3.782 4.98-1.247 3.131-.877 6.5 1.103 10.02Zm-1.406.549c-1.01-1.835-1.622-3.638-1.838-5.409L20.5 30.283l1.16 5.216.016-.012 2.24-1.69Zm11.584-3.515-1.577-1.894c-.214 1.768-.825 3.57-1.834 5.409l2.236 1.687.017.012 1.158-5.214Z"
    />
  </svg>
);
export default TechDrivenSVG;
